import Utils from '../../util.js';

class Tag extends HTMLElement {

    #template = document.createElement('template');
    $templateMarkup = `
        <span></span>
    `;

    static validTypes = {
        DEFAULT: 'default',
        HIGH: 'high',
        MEDIUM: 'medium',
        LOW: 'low',
        SPECIAL: 'special'
    }
    
    constructor() {
        super();
        this.attachShadow({mode: 'open'});
        this.addStyle = Utils.addStyle;
        this.addStyle('/src/styles/neptune.css');
        this.addStyle('/src/components/atoms/tag/tag.css');
        this.#template.innerHTML = this.$templateMarkup;
        this.shadowRoot.appendChild(this.#template.content.cloneNode(true));
        this.addValueToAttribute = Utils.addValueToAttribute;
        this.removeValueFromAttribute = Utils.removeValueFromAttribute;
        this.failed = false;

        this.mutationObserver = new MutationObserver(() => {
            if(!this.failed) {
                this.setTag();
            }
        });

        this.mutationObserver.observe(this, { childList: true, characterData: true, subtree: true });
    }

    disconnectedCallback() {
        this.mutationObserver.disconnect();
    }

    connectedCallback() {
        if(this.failed) {
            return;
        }
        this.setTag();
    }

    static get observedAttributes() {
        return ['left-icon', 'type'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if(oldValue === newValue) {
            return;
        }
        if(this.isConnected) {
            this.setTag();
        }
    }

    setTag() {
        if(this.failed) {
            return;
        }
        const tagElement = this.shadowRoot.querySelector('span');

        let leftIcon = (this.getAttribute('left-icon') || '').trim().toLowerCase();
        let type = (this.getAttribute('type') || '').trim().toLowerCase();

        if(!Object.values(Tag.validTypes).includes(type)) {
            this.failed = true;
            throw new Error(`Invalid type value "${type}" for <neptune-tag>. The valid types are: ${Object.values(Tag.validTypes).join(', ')}.`);
        }

        this.setAttribute('type', type);

        const fragment = new DocumentFragment();

        if(leftIcon) {
            const leftIconElement = this.#createIcon(leftIcon);
            fragment.appendChild(leftIconElement);
        }

        const textContent = this.textContent.trim();
        if(textContent) {
            const textElement = this.#createText(textContent);
            fragment.appendChild(textElement);
        }

        tagElement.innerHTML = '';
        tagElement.appendChild(fragment);
    }

    #createIcon(iconName) {
        const iconElement = document.createElement('i');
        iconElement.className = 'material-symbols-rounded';
        iconElement.textContent = iconName;
        return iconElement;
    }

    #createText(text) {
        const textElement = document.createElement('span');
        textElement.textContent = text;
        return textElement;
    }
}

customElements.define('neptune-tag', Tag);

export default Tag;